import React from "react";
import "./PostAuthor.scss";
import { HeadingMedium, HeadingSmall, ParagraphMomento } from "@tumomento/ui";
import { parseDate } from "@/utils/functions";
import { getImage } from "gatsby-plugin-image";
import { useDimensions } from "@/hooks/useDimensions";
export const PostAuthor = ({ blog }: any) => {
  const { isMobile } = useDimensions();
  const { description, image, name, linkedin } = blog.author;
  const imageAuthor = image?.url;
  return (
    <div className="postAuthor">
      <div className="postAuthor__Card">
        <div className="postAuthor__Card__Left">
          <div className="postAuthor__Card__Line"></div>
          <HeadingSmall color="green2" className="pb-4">
            {blog.category[0]}
            <br />
            Fecha en {parseDate(blog.publishDate)}
          </HeadingSmall>
        </div>
        <div className="postAuthor__Card__Right">
          <ParagraphMomento
            color="green3"
            typography="heading-l"
            className={isMobile ? "pb-3" : "postAuthor__Title"}
          >
            El Autor
          </ParagraphMomento>
          <div className="postAuthor__author flex">
            <div className="postAuthor__author__image">
              <img src={imageAuthor} alt={name} />
              {isMobile && (
                <ParagraphMomento
                  typography="heading-s"
                  color="content1"
                  className="ps-2 clickeable"
                  onClick={
                    !!!linkedin
                      ? undefined
                      : () => window.open(linkedin, "_blank")
                  }
                >
                  {name}
                </ParagraphMomento>
              )}
            </div>
            <div className="postAuthor__author__name">
              {!isMobile && (
                <ParagraphMomento
                  typography="heading-s"
                  color="content1"
                  className="clickeable"
                  onClick={
                    !!!linkedin
                      ? undefined
                      : () => window.open(linkedin, "_blank")
                  }
                >
                  {name}
                </ParagraphMomento>
              )}
              {!!!!description?.description && (
                <ParagraphMomento
                  color="content2"
                  className={isMobile ? "pt-3" : "pt-6"}
                >
                  {description.description}
                </ParagraphMomento>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
